import styled from 'styled-components';

export const ButtonWrapper = styled.div`
  position: absolute;
  bottom: 8px;
  right: 8px;
  
  button {
    border-radius: 50% !important;
    width: 24px !important;
    height: 24px !important;    
    padding: 0 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }
`;

export const ScrollableContainer = styled.div`
  max-height: calc(100vh - 200px);
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 4px;
  
  /* Custom scrollbar styles */
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
`;

export const HighlightsContainer = styled.div`
  display: flex;
  gap: 16px;
`;

export const MetricContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #E0E0E0;
  border-radius: 8px;
  padding: 16px;
  flex: 1;
`;

export const MetricContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const TagWrapper = styled.div`
  & > div {
    width: 40px;
    height: 40px;
  }
`;

export const WorkflowImageContainer = styled.div`
  display: flex;
  justify-content: center;
  border: 1px solid #E0E0E0;
  border-radius: 8px;
  position: relative;
`;

export const AvatarContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const OverviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const OverviewInfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 8px 0;
`;

export const OverviewInfoColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const WorkflowContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const WorkflowSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;